import React from 'react';
import CompanyOffersTable from './components/CompanyOffersTable/CompanyOffersTable';
import styles from './CompanyOffers.module.scss';
import { Button } from '../../../common/_custom';
import WhiteBackGroundPencilIcon from '../../../assets/Svg/WhiteBackGroundPencilIcon';
import { OffersReturn, useUploadData } from '../UploadData/useUploadData';
import { USER_TYPE } from '../../../common/ManageDealDrawer/DealDrawerConstants';
import { useCompanyOffers } from './components/useCompanyOffers';
import { OFFERS_TEXT, OFFERS_CONFIG, CAPITAL_REQUIREMENT_BUTTON } from './components/OffersConstants';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Mixpanel } from '../../../utils/mixpanel';
import { getSubdomain } from '../../../utils/utils';
import { AICA_VISIT_RECUR_PLATFORM } from '../../../utils/constants/mixpanelEvents/companyEvents';
import { setDealDrawer } from '../../../store/investor/action';
import { editProfileIcon } from '../../../assets/hostedassets';
import ManageDealDrawer from '../../../common/ManageDealDrawer/ManageDealDrawer';

interface Offer {
    name: string;
    product: string;
    createDate: string;
    amount: number;
    status: string;
}
const RECUR_REDIRECT_URL = process.env.REACT_APP_RECUR_REDIRECT_URL;

const CompanyOffers: React.FC = () => {
    const dispatch = useAppDispatch();
    const { openCapitalRequirementDrawer } = useUploadData({
        userType: USER_TYPE.COMPANY,
        mode: 'offers',
    }) as OffersReturn;
    const { dealsData, fetchingDeals, companyMetrics } = useCompanyOffers();
    const isRecurPno = window.location.pathname.includes(process.env.REACT_APP_RECUR_PNO_DOMAIN || '');
    const user = useAppSelector((state) => state.user.userData);
    const dealDrawerState = useAppSelector((state) => state.investor.dealDrawer);

    const navigateUserToRRF = () => {
        Mixpanel.track(AICA_VISIT_RECUR_PLATFORM, {
            userRole: user?.accountType,
            pnoPlatform: getSubdomain(),
            userId: user?.userId,
            currentUrl: window.location.href,
            organizationId: user?.assesseeOrgId,
        });

        const redirectUrl = `${RECUR_REDIRECT_URL}?referrerEmail=${encodeURIComponent(user?.primaryEmail)}`;
        const a = document.createElement('a');
        a.href = redirectUrl;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.click();
    };

    return (
        <div className={styles.offersPage}>
            {true && (
                <div className={styles.RecurPnoBanner}>
                    <span>
                        We've upgraded your experience! Can't find something?{' '}
                        <span
                            onClick={() => navigateUserToRRF()}
                            style={{ color: '#6021B3', cursor: 'pointer', fontFamily: 'gilroy-semibold' }}
                        >
                            Visit Classic Platform
                        </span>
                    </span>
                </div>
            )}
            <div className={styles.offersPageContainer}>
                <div className={styles.pageHeader}>
                    <span className={styles.heading}>{OFFERS_TEXT.PAGE_TITLE}</span>
                    {companyMetrics && Object.keys(companyMetrics).length > 0 && (
                        <Button
                            variant="purple"
                            text={CAPITAL_REQUIREMENT_BUTTON}
                            onClick={() => {
                                dispatch(
                                    setDealDrawer({
                                        open: true,
                                        drawerLabel: CAPITAL_REQUIREMENT_BUTTON,
                                    }),
                                );
                            }}
                            size="small"
                            style={{ height: OFFERS_CONFIG.BUTTON_HEIGHT, margin: '0px' }}
                            iconStyles={{ marginRight: 8, marginBottom: 5 }}
                            icon={<WhiteBackGroundPencilIcon width={20} height={20} fill="black" />}
                        />
                    )}
                </div>
                <div className={styles.offersTableContainer}>
                    <CompanyOffersTable
                        rows={dealsData?.data || []}
                        loading={fetchingDeals}
                        openCapitalRequirementDrawer={openCapitalRequirementDrawer}
                        showEmptyStateButton={!companyMetrics || Object.keys(companyMetrics).length === 0}
                    />
                </div>
            </div>

            {dealDrawerState.open && <ManageDealDrawer source="Debt Products" />}
        </div>
    );
};

export default CompanyOffers;
